import { useBindCx } from "@scalar/use-hooks/useBindCx";
import { createElementBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, unref } from "vue";
var ScalarCopyBackdrop_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	inheritAttrs: false,
	__name: "ScalarCopyBackdrop",
	setup(__props) {
		const { cx } = useBindCx();
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", normalizeProps(guardReactiveProps(unref(cx)("absolute inset-y-0.5 -z-2 left-0 right-0 bg-b-1 rounded"))), null, 16);
		};
	}
});
//#endregion
export { ScalarCopyBackdrop_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarCopyBackdrop.vue.script.js.map